module.exports = __webpack_public_path__ + "img/Iframe.4bd53837.png";